import { buildCaseloadFigures, buildSampleDigest } from '@innerhive-internal/innerhive-common';
import type { IAgencyInsights } from './useAgencyInsights';
import { IAvatarIdentity } from '../../avatar/IAvatarIdentity';

/** How many clients the invented caseload has, which is how many photos a showing of it deals. */
export const DEMO_CLIENT_COUNT = buildSampleDigest(new Date()).clients.length;

/** Each invented client's face: the portrait dealt to them, read as stored since it ships with the app. */
const demoIdentity = (params: { careMapIds: string[]; careMapId: string; photos: string[] }): IAvatarIdentity | undefined => {
    const { careMapIds, careMapId, photos } = params;
    const index = careMapIds.indexOf(careMapId);
    if (index < 0 || photos.length === 0) {
        return undefined;
    }
    return { photo: photos[index % photos.length], avatar: undefined, color: undefined, links: undefined, photoHasNoAuditedRoute: true };
};

/**
 * What the tab shows under the admin-only demo setting: the invented caseload, and nobody real.
 * `photos` is the deal for this showing of the demo, one per client in the digest's order.
 */
export const buildDemoInsights = (params: { now: Date; retry: () => Promise<void>; photos: string[] }): IAgencyInsights => {
    const { now, retry, photos } = params;
    const figures = buildCaseloadFigures(buildSampleDigest(now));
    const careMapIds = figures.digest.clients.map(client => client.careMapId);
    return {
        ...figures,
        hasLoaded: true,
        nothingReadable: false,
        isDemo: true,
        unreadableClients: [],
        retry,
        clientAvatar: careMapId => demoIdentity({ careMapIds, careMapId, photos }),
        clientReading: careMapId => figures.digest.baselines.find(baseline => baseline.careMapId === careMapId)?.reading
    };
};
